// shared-ui/src/lib/api/cache.js
const apiCache = new Map();

export function getCached(key) {
  return apiCache.get(key);
}

export function setCached(key, value) {
  apiCache.set(key, value);
}

export function clearCache(key) {
  if (key) {
    apiCache.delete(key);
  } else {
    apiCache.clear();
  }
}

export function clearAllCache() {
  apiCache.clear();
}
